<template>
  <b-form
    ref="webviewForm"
    novalidate
    :validated="validated">
    <b-form-group class="ml-3 mt-4">
      <b-form-checkbox
        v-model="config.enabled"
        size="lg"
        switch>
        Enable Web View
      </b-form-checkbox>
      <template
        v-if="config.enabled"
        v-slot:description>
        Web view will be displayed on client devices
      </template>
      <template
        v-else
        v-slot:description>
        Web view will NOT be displayed on client devices
      </template>
    </b-form-group>
    <b-card
      title="Title"
      class="mt-0">
      <b-form-group
        :disabled="isDisabled"
        invalid-feedback="Title is required">
        <b-form-input
          v-model="config.title"
          type="text"
          :required="!isDisabled" />
      </b-form-group>
    </b-card>
    <b-card
      title="Web View URLs"
      class="mt-0">
      <b-form-group
        label="English URL"
        :disabled="isDisabled"
        invalid-feedback="Value must be a valid URL">
        <b-form-input
          v-model="config.urls.en"
          type="url"
          :required="!isDisabled" />
      </b-form-group>
      <b-form-group
        label="Spanish URL"
        :disabled="isDisabled"
        invalid-feedback="Value must be a valid URL">
        <b-form-input
          v-model="config.urls.es"
          type="url"
          :required="!isDisabled" />
      </b-form-group>
      <b-form-group :disabled="isDisabled">
        <b-form-checkbox
          v-model="config.addAuthorizationHeader"
          switch>
          Add Authorization Header
        </b-form-checkbox>
        <template
          v-if="config.addAuthorizationHeader"
          v-slot:description>
          Clients will include the Authorization header when requesting the webview
        </template>
        <template
          v-else
          v-slot:description>
          Clients will NOT include the Authorization header when requesting the webview
        </template>
      </b-form-group>
    </b-card>
    <b-card title="Tab Bar">
      <b-form-group
        label="Title"
        description="This value should correspond to a key in the application's localization bundle"
        :disabled="isDisabled"
        invalid-feedback="Title is required">
        <b-form-input
          v-model="config.tabBar.title"
          :required="!isDisabled" />
      </b-form-group>
      <b-form-group
        label="Spanish Title"
        description="This value should correspond to a key in the application's localization bundle"
        :disabled="isDisabled"
        invalid-feedback="Title is required">
        <b-form-input
          v-model="config.tabBar.titleEs"
          :required="!isDisabled" />
      </b-form-group>
      <web-view-image-selection
        v-model="config.tabBar.unselectedImage"
        label="Unselected Image"
        :disabled="isDisabled" />
      <web-view-image-selection
        v-model="config.tabBar.selectedImage"
        label="Selected Image"
        :disabled="isDisabled" />
    </b-card>
    <b-card title="More Menu">
      <b-form-group
        label="Title"
        description="This value should correspond to a key in the application's localization bundle"
        :disabled="isDisabled"
        invalid-feedback="Title is required">
        <b-form-input
          v-model="config.moreMenu.title"
          :required="!isDisabled" />
      </b-form-group>
      <b-form-group
        label="Spanish Title"
        description="This value should correspond to a key in the application's localization bundle"
        :disabled="isDisabled"
        invalid-feedback="Title is required">
        <b-form-input
          v-model="config.moreMenu.titleEs"
          :required="!isDisabled" />
      </b-form-group>
      <web-view-image-selection
        v-model="config.moreMenu.image"
        :disabled="isDisabled" />
    </b-card>
  </b-form>
</template>

<script>
  import WebViewImageSelection from "./WebViewImageSelection"
  import webview from "@/services/webview"
  import {mapGetters} from "vuex"

  export default {
    name: "WebViewForm",
    components: {
      WebViewImageSelection,
    },
    props: {
      value: {
        type: Object,
        default: () => ({
          ...webview.newConfig(),
        }),
      },
    },
    data: () => ({
      validated: false,
    }),
    computed: {
      ...mapGetters([
        "canWebviewEdit",
      ]),
      config: {
        get: function() {
          return this.value
        },
        set: function(value) {
          this.$emit("input", value)
        },
      },
      isDisabled() {
        return !this.canWebviewEdit || !this.config.enabled
      },
    },
    methods: {
      isValid() {
        this.validated = true
        return this.$refs.webviewForm.checkValidity()
      },
    },
  }
</script>

<style scoped>

  .card {
    margin: 1.5rem 0;
  }

</style>
